<template>
    <div class="worker-app min-vh-100 h-100 d-flex">

        <Sidebar :mobile-open="sidebarOpen" @navigate="closeSidebar()" />

        <div
            class="worker-sidebar-backdrop d-md-none"
            v-if="sidebarOpen"
            @click="closeSidebar()"
        />

        <div id="content-wrapper" class="d-flex flex-column w-100">

            <div
                class="worker-topbar d-flex d-md-none align-items-center bg-primary text-white px-3 sticky-top"
            >
                <BLink class="text-white p-2 mr-2" @click="toggleSidebar()" aria-label="Menu">
                    <i class="fad fa-bars fa-lg" />
                </BLink>
                <span class="font-weight-800 text-uppercase">Lemigas</span>
            </div>

            <div id="content" class="flex-grow-1">
                <div v-if="applicationEnabled">
                    <RouterView />
                </div>
                <div class="d-flex justify-content-center align-items-center h-100" v-else>
                    <div class="text-center">
                        <i class="fa-thin fa-cloud-exclamation fa-4x mb-5 text-danger" />
                        <div class="mb-5 display-4">
                            Aplikace vyžaduje pro současné i připravované funkcionality oprávnění pro fotoaparát a
                            polohu.
                            <br />
                            <br />
                            Udělte patřičná oprávnění a obnovte stránku.
                        </div>
                        <div>
                            <PrimaryButton @click="reloadWindow()" text="Obnovit stránku" />
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import PrimaryButton from "../Common/UI/Button/PrimaryButton.vue"
import Sidebar from "./Component/Sidebar.vue"

export default {

    components: {
        PrimaryButton,
        Sidebar,
    },

    data() {
        return {
            development: (process.env.NODE_ENV !== "production"),
            applicationEnabled: true,
            sidebarOpen: false,
        }
    },

    watch: {

        // Navigating from anywhere else (back button, in-page link) must not
        // leave the drawer open over the new page.
        $route() {
            this.closeSidebar()
        },

    },

    methods: {

        toggleSidebar() {
            this.sidebarOpen = !this.sidebarOpen
        },

        closeSidebar() {
            this.sidebarOpen = false
        },

        checkPermissions() {
            if (!window.location.hostname.includes('localhost')) {
                navigator.permissions.query({ name: "geolocation" }).then((result) => {
                    if (result.state !== "granted") {
                        this.applicationEnabled = false
                        this.tryGeolocation()
                    }
                })
            }
        },

        tryGeolocation() {
            if (!window.location.hostname.includes('localhost')) {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        console.log("Latitude: " + position.coords.latitude)
                        console.log("Longitude:" + position.coords.longitude)
                    },
                    error => {
                        if (error.code === error.PERMISSION_DENIED) {
                            this.applicationEnabled = false
                        }
                    },
                )
            }

        },

        reloadWindow() {
            window.location.reload()
        },

    },

    mounted() {
        this.checkPermissions()
    },

}
</script>
